var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define('views/navigation/SubHeaderView',['require','underscore','evertrue','ET/ETView','models/FeaturesModel'],function(require) {
  var ETView, EverTrue, FeaturesModel, SubHeaderView, _;
  _ = require("underscore");
  EverTrue = require("evertrue");
  ETView = require("ET/ETView");
  FeaturesModel = require("models/FeaturesModel");
  return SubHeaderView = (function(_super) {
    __extends(SubHeaderView, _super);

    function SubHeaderView() {
      return SubHeaderView.__super__.constructor.apply(this, arguments);
    }

    SubHeaderView.prototype.pathOverrides = {};

    SubHeaderView.prototype.excludes = ["reporting"];

    SubHeaderView.prototype.initialize = function() {
      this.model = new FeaturesModel();
      this.model.init();
      this.model.on("change", (function(_this) {
        return function() {
          return _this.getNavItems();
        };
      })(this));
      return EverTrue.vent.on("navChange", ((function(_this) {
        return function() {
          _this.currentFeature = void 0;
          return _this.getNavItems();
        };
      })(this)), this);
    };

    SubHeaderView.prototype.getNavItems = function() {
      if (!this.currentFeature) {
        this.getCurrentFeature();
      }
      this.navData = this.model.getChildrenFor(this.currentFeature);
      return this.render();
    };

    SubHeaderView.prototype.getCurrentFeature = function() {
      var path;
      path = Backbone.history.location.pathname;
      return _.each(this.model.getParents(), (function(_this) {
        return function(feature) {
          var _ref;
          if (((_ref = _this.pathOverrides[feature]) != null ? _ref.match(path) : void 0) || path.match(feature)) {
            return _this.currentFeature = feature;
          }
        };
      })(this));
    };

    SubHeaderView.prototype.render = function(done) {
      var data, template_name;
      data = {
        active: Backbone.history.location.pathname.slice(1)
      };
      template_name = "navigation/sub_headers/" + this.currentFeature + ".html";
      _.each(this.navData, function(feature) {
        return data[feature.split(":")[1]] = true;
      });
      if (!this.currentFeature || _.isEmpty(this.navData) || (this.navData.length === 1) || _.contains(this.excludes, this.currentFeature)) {
        return $(".sub-navigation").empty().hide();
      } else {
        return EverTrue.fetchTemplate(template_name, (function(_this) {
          return function(name) {
            return dust.render(name, data, function(err, out) {
              _this.$el.html(out);
              return $(".sub-navigation").html(_this.$el).show();
            });
          };
        })(this));
      }
    };

    return SubHeaderView;

  })(ETView);
});

//# sourceMappingURL=SubHeaderView.js.map
;
